import { useMemo, useState } from "react";
import TeamCard from "../components/TeamCard";
import type { AppDataState } from "../api/useAppData";
import { ownerNames } from "../../shared/owners";

export default function TeamsPage({ state }: { state: AppDataState }) {
  const { data } = state;
  const [filter, setFilter] = useState<string>("all");

  const teams = useMemo(() => {
    if (!data) return [];
    const list = data.teamStats.filter((t) => t.owner);
    if (filter === "all") return list;
    return list.filter((t) => t.owner === filter);
  }, [data, filter]);

  if (!data) return <p>Loading…</p>;

  return (
    <>
      <h1>Teams</h1>
      <div className="chart-toolbar" role="group" aria-label="Owner filter">
        <button
          type="button"
          className={`chip${filter === "all" ? " active" : ""}`}
          onClick={() => setFilter("all")}
        >
          All
        </button>
        {ownerNames.map((o) => (
          <button
            key={o}
            type="button"
            className={`chip${filter === o ? " active" : ""}`}
            onClick={() => setFilter(o)}
          >
            {o}
          </button>
        ))}
      </div>
      <div className="team-grid full">
        {teams.map((t) => (
          <TeamCard key={t.team} team={t} />
        ))}
      </div>
    </>
  );
}
